var exports = {
  "wrapper": "xaee3c4fa--f81f3d--wrapper",
  "wave-animation": "xaee3c4fa--f81f3d--wave-animation",
  "text-22": "xaee3c4fa--f81f3d--text-22",
  "has-height": "xaee3c4fa--f81f3d--has-height",
};

module.exports = exports;
